import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { isEmpty } from "lodash";


import {
  getCompanyDetails,
  getCompanyToUserList,
  getCompanyToUserListSuccess,
  updateCompanyDetails,
  updateCompanyDetailsSuccess,
} from "../../../../store/companyToUser/action";

export default function CustomerDetailsUpdate({}) {
  const dispatch = useDispatch();

  const createCompanyInit = {
    BusinessName: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    RegNo: "",
    VatNo: "",
    ContactTelephoneNumber: "",
    ContactEmailAddress: "",
    FlagVatEnabled: "",
    LogoUrl: "",
    WebsiteUrl: "",
    //invoice registered address
    InvoiceAddressLine1: "",
    InvoiceAddressLine2: "",
    InvoiceAddressLine3: "",
    InvoiceAddressLine4: "",
    InvoiceAddressCity: "",
    InvoiceAddressCounty: "",
    InvoiceAddressPostCode: "",
  };

  const [companyData, setCompanyData] = useState(createCompanyInit);

  const { companyDetailsAPI } = useSelector((state) => ({
    companyDetailsAPI: state.CompanyToUser.companyDetails,
  }));
  useEffect(() => {
    if (isEmpty(companyDetailsAPI)) return;
    if (companyDetailsAPI.status === 200) {
      setCompanyData({
        ...companyData,
        BusinessName: companyDetailsAPI?.company_data?.BusinessName,
        AddressLine1: companyDetailsAPI?.company_data?.AddressLine1,
        AddressLine2: companyDetailsAPI?.company_data?.AddressLine2,
        AddressLine3: companyDetailsAPI?.company_data?.AddressLine3,
        AddressLine4: companyDetailsAPI?.company_data?.AddressLine4,
        AddressCity: companyDetailsAPI?.company_data?.AddressCity,
        AddressCounty: companyDetailsAPI?.company_data?.AddressCounty,
        AddressPostCode: companyDetailsAPI?.company_data?.AddressPostCode,
        AddressCountry: companyDetailsAPI?.company_data?.AddressCountry,
        RegNo: companyDetailsAPI?.company_data?.RegNo,
        VatNo: companyDetailsAPI?.company_data?.VatNo,
        ContactTelephoneNumber:
          companyDetailsAPI?.company_data?.ContactTelephoneNumber,
        ContactEmailAddress:
          companyDetailsAPI?.company_data?.ContactEmailAddress,
        FlagVatEnabled: companyDetailsAPI?.company_data?.FlagVatEnabled,
        LogoUrl: companyDetailsAPI?.company_data?.LogoUrl,
        WebsiteUrl: companyDetailsAPI?.company_data?.WebsiteUrl,
      });
    } else {
      toast.error(companyDetailsAPI.message);
      setCompanyData(createCompanyInit);
    }
  }, [companyDetailsAPI]);
  useEffect(() => {
    dispatch(getCompanyDetails());
  }, []);

  const handleUpdateCompany = () => {
    // VAT registration is authoritative in the dated history (managed by the
    // VatRegistrationHistory panel + synced server-side), so never let a plain
    // company save overwrite the cached FlagVatEnabled / VatNo.
    const { FlagVatEnabled, VatNo, ...companyDataToSave } = companyData;
    dispatch(updateCompanyDetails([companyDataToSave]));
  };
  const { updateCompanyDetailsSuccessAPI } = useSelector((state) => ({
    updateCompanyDetailsSuccessAPI:
      state.CompanyToUser.updateCompanyDetailsSuccess,
  }));

  useEffect(() => {
    if (isEmpty(updateCompanyDetailsSuccessAPI)) return;
    if (updateCompanyDetailsSuccessAPI.status === 200) {
      toast.success(updateCompanyDetailsSuccessAPI.message);
      dispatch(getCompanyToUserListSuccess([]));
      dispatch(getCompanyToUserList());
      // set local storage with new logo ?.get_company_data?.Company_LogoUrl
      const authUserLogo = JSON.parse(localStorage.getItem("authUser"));
      authUserLogo.get_company_data.Company_LogoUrl = companyData.LogoUrl;
      localStorage.setItem("authUser", JSON.stringify(authUserLogo));
      // setModalSelectCompany(true);
    } else {
      toast.error(updateCompanyDetailsSuccessAPI.message);
    }
    dispatch(updateCompanyDetailsSuccess([]));
  }, [updateCompanyDetailsSuccessAPI]);

  // convert file to base64
  const handleFileConvertToBase64 = (file) => {
    // Check if the file is an image if it is convert to base 64 and return it
    if (file.type.match("image.*")) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setCompanyData({
          ...companyData,
          LogoUrl: reader.result,
        });
      };
      reader.onerror = (error) => {
        //
      };
      return reader.result;
    }
  };

  return (
    <>
      <Card>
        <CardHeader className="bg-light p-3">
          <div>
            <span className={"fs-14"}>Update Your Business Details</span>
          </div>
        </CardHeader>
        <CardBody>
          <div>
            <div>
              {/*{createCompanyLoadingAPI ? (*/}
              {/*  <LoadingSpinner*/}
              {/*    title={"One moment, we're building your account."}*/}
              {/*    extraText={*/}
              {/*      "Usually takes up to 30 seconds. Please do not refresh this window."*/}
              {/*    }*/}
              {/*  />*/}
              {/*) : (*/}
              <div>
                <h1>Enter your business details</h1>
                <div className={"d-flex "}>
                  <div className={"   "}>
                    <Row>
                      <Col lg={12} className={"pb-2"}>
                        <div className={""}>
                          <h6>Company Logo</h6>
                          <img
                            style={{ maxWidth: "120px", maxHeight: "50px" }}
                            src={
                              //   base 64 to image
                              companyData?.LogoUrl
                            }
                            alt=""
                          />
                        </div>
                      </Col>
                      <Col lg={12} className={"pb-2"}>
                        {" "}
                        <div>
                          <Label>Business Name</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.BusinessName}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                BusinessName: e.target.value,
                              });
                            }}
                          />
                        </div>{" "}
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label>Address Line 1</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressLine1}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressLine1: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label>Address Line 2</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressLine2}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressLine2: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Address Line 3</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressLine3}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressLine3: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Address Line 4</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressLine4}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressLine4: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>City</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressCity}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressCity: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>County</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressCounty}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressCounty: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Post Code</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressPostCode}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressPostCode: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Country</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.AddressCountry}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                AddressCountry: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Company Email</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.ContactEmailAddress}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                ContactEmailAddress: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Company Phone Number</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.ContactTelephoneNumber}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                ContactTelephoneNumber: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Website Url</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.WebsiteUrl}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                WebsiteUrl: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Company Registration Number</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.RegNo}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                RegNo: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12} className={"mt-2"}>
                        <div className="alert alert-info mb-0 py-2">
                          <i className="ri-information-line align-bottom me-1" />
                          VAT registration (your VAT number and the dates you
                          were registered) is now managed in the{" "}
                          <strong>VAT Registration History</strong> panel below,
                          so historical invoices always show the VAT status that
                          applied on their date.
                        </div>
                      </Col>
                      <div className={"my-2"}></div>
                      <hr />
                      {/*Invoice address*/}
                      <Col lg={12}>
                        <div>
                          <h6>Invoice Address</h6>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label>Address Line 1</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressLine1}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressLine1: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label>Address Line 2</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressLine2}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressLine2: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Address Line 3</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressLine3}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressLine3: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Address Line 4</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressLine4}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressLine4: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>City</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressCity}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressCity: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>County</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressCounty}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressCounty: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6} className={"mt-2"}>
                        <div>
                          <Label>Post Code</Label>
                          <input
                            type="text"
                            className={"form-control"}
                            value={companyData.InvoiceAddressPostCode}
                            onChange={(e) => {
                              setCompanyData({
                                ...companyData,
                                InvoiceAddressPostCode: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <div className={"my-2"}></div>
                      <hr />

                      <Col lg={12}>
                        <div className={"pt-2"}>
                          <div>
                            <h6>Upload Logo</h6>
                          </div>
                          <div>
                            <input
                              type="file"
                              className={"form-control"}
                              onChange={(e) => {
                                setCompanyData({
                                  ...companyData,
                                  LogoUrl:
                                    //base 64
                                    handleFileConvertToBase64(
                                      e.target.files[0]
                                    ),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className={"text-center pt-4"}>
                          <button
                            className={"btn btn-success"}
                            onClick={() => {
                              handleUpdateCompany();
                            }}
                          >
                            Update Company
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              {/*)}*/}
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
